import {
  buildStatisticsExportBlock,
  exportStatisticsCSV,
  exportStatisticsPDF,
  exportStatisticsXLS
} from './summaryExport'

import {
  buildTripsExportBlock,
  exportTripsCSV,
  exportTripsPDF,
  exportTripsXLS
} from './tripsExport'

import {
  buildCostsExportBlock,
  exportCostsCSV,
  exportCostsPDF,
  exportCostsXLS
} from './costsExport'

import {
  buildEmissionsExportBlock,
  exportEmissionsCSV,
  exportEmissionsPDF,
  exportEmissionsXLS
} from './emissionsExport'

import {
  buildVehicleExportBlock,
  exportVehiclesCSV,
  exportVehiclesPDF,
  exportVehiclesXLS
} from './vehiclesExport'

const buildCurrentStatsExportBlocks = ({
  activeTab,
  stats,
  selectedVehicleName,
  language,
  t
}) => ({
  activeTab,

  statisticsExportBlock: buildStatisticsExportBlock(
    stats,
    stats?.tripsPeriodText,
    selectedVehicleName,
    language,
    t
  ),

  tripsExportBlock: buildTripsExportBlock(
    stats,
    stats?.tripsPeriodText,
    selectedVehicleName,
    language,
    t
  ),

  costsExportBlock: buildCostsExportBlock(
    stats,
    stats?.tripsPeriodText,
    selectedVehicleName,
    language,
    t
  ),

  emissionsExportBlock: buildEmissionsExportBlock(
    stats,
    stats?.tripsPeriodText,
    selectedVehicleName,
    t
  ),

  vehicleExportBlock: buildVehicleExportBlock(
    stats?.vehiclesStats,
    stats?.tripsPeriodText,
    stats?.statsMode
  )
})

export const exportCurrentStatsCSV = (options) => {
  const {
    activeTab,
    statisticsExportBlock,
    tripsExportBlock,
    costsExportBlock,
    emissionsExportBlock,
    vehicleExportBlock
  } = buildCurrentStatsExportBlocks(options)

  if (activeTab === 'trips') {
    exportTripsCSV(tripsExportBlock, options.t)
    return
  }

  if (activeTab === 'costs') {
    exportCostsCSV(costsExportBlock, options.t)
    return
  }

  if (activeTab === 'emissions') {
    exportEmissionsCSV(
      emissionsExportBlock,
      options.t
    )
    return
  }

  if (activeTab === 'vehicles') {
    exportVehiclesCSV(
      vehicleExportBlock,
      options.t
    )
    return
  }

  exportStatisticsCSV(
    statisticsExportBlock,
    options.t
  )
}

export const exportCurrentStatsXLS = async (options) => {
  const {
    activeTab,
    statisticsExportBlock,
    tripsExportBlock,
    costsExportBlock,
    emissionsExportBlock,
    vehicleExportBlock
  } = buildCurrentStatsExportBlocks(options)

  if (activeTab === 'trips') {
    await exportTripsXLS(
      tripsExportBlock,
      options.t
    )
    return
  }

  if (activeTab === 'costs') {
    await exportCostsXLS(
      costsExportBlock,
      options.t
    )
    return
  }

  if (activeTab === 'emissions') {
    await exportEmissionsXLS(
      emissionsExportBlock,
      options.t
    )
    return
  }

  if (activeTab === 'vehicles') {
    await exportVehiclesXLS(
      vehicleExportBlock,
      options.t
    )
    return
  }

  await exportStatisticsXLS(
    statisticsExportBlock,
    options.t
  )
}

export const exportCurrentStatsPDF = async (options) => {
  const {
    activeTab,
    statisticsExportBlock,
    tripsExportBlock,
    costsExportBlock,
    emissionsExportBlock,
    vehicleExportBlock
  } = buildCurrentStatsExportBlocks(options)

  if (activeTab === 'trips') {
    await exportTripsPDF(
      tripsExportBlock,
      options.t
    )
    return
  }

  if (activeTab === 'costs') {
    await exportCostsPDF(
      costsExportBlock,
      options.t
    )
    return
  }

  if (activeTab === 'emissions') {
    await exportEmissionsPDF(
      emissionsExportBlock,
      options.t
    )
    return
  }

  if (activeTab === 'vehicles') {
    await exportVehiclesPDF(
      vehicleExportBlock,
      options.t
    )
    return
  }

  await exportStatisticsPDF(
    statisticsExportBlock,
    options.t
  )
}

export {
  buildStatisticsExportBlock,
  buildVehicleExportBlock,
  exportStatisticsCSV,
  exportStatisticsPDF,
  exportStatisticsXLS,
  exportVehiclesCSV,
  exportVehiclesPDF,
  exportVehiclesXLS
}